import { defineComponent as z, ref as I, computed as k, watchEffect as K, openBlock as u, createElementBlock as v, createElementVNode as g, normalizeStyle as Q, toDisplayString as S, createCommentVNode as f, createBlock as L, unref as o, onMounted as R, onBeforeUnmount as pe, useAttrs as G, useSlots as V, watch as de, normalizeClass as X, renderSlot as C, withDirectives as me, vShow as ge, inject as Z, withCtx as T, createVNode as y, createTextVNode as D, mergeProps as ve, provide as Y, createSlots as x, renderList as j, Fragment as q } from "vue";
import { useI18n as O } from "vue-i18n";
import N from "@patsnap-biz/icon";
import "@patsnap-ui/icon/assets/solid/ArrowRight.svg";
import "@patsnap-ui/icon/assets/solid/AvatarBlue.svg";
import { onClickOutside as ee } from "@vueuse/core";
import F from "@patsnap-biz/list";
import { getSlotName as A, UserCenterService as fe, HeaderService as he } from "@patsnap-utils/biz";
import $ from "lodash";
import be from "@patsnap-biz/dialog";
import Te from "@patsnap-biz/toast";
import { ElTooltip as ye } from "element-plus";
import "element-plus/es/components/tooltip/style/css";
import te from "@patsnap-biz/header-widget";
import "@patsnap-ui/icon/assets/solid/ChangeOrder.svg";
import "@patsnap-ui/icon/assets/solid/tick.svg";
import "@patsnap-ui/icon/assets/solid/LoadingBars.svg";
import "@patsnap-ui/icon/assets/solid/TranslateEnglish.svg";
import "@patsnap-ui/icon/assets/solid/DropdownOpen.svg";
import "@patsnap-ui/icon/assets/solid/DropdownRight.svg";
import "@patsnap-ui/icon/assets/solid/DropdownClose.svg";
import "@patsnap-ui/icon/assets/solid/users.svg";
import "@patsnap-ui/icon/assets/solid/settings.svg";
import "@patsnap-ui/icon/assets/solid/logout.svg";
import "@patsnap-ui/icon/assets/solid/profile.svg";
import "@patsnap-ui/icon/assets/solid/login.svg";
const _e = { class: "patsnap-biz-avatar-wrapper w-full h-12 flex items-center justify-center gap-2 cursor-pointer" }, ke = { key: 0 }, we = ["title"], ae = /* @__PURE__ */ z({
  __name: "Avatar",
  props: {
    username: {
      type: String,
      default: ""
    },
    email: {
      type: String,
      default: ""
    },
    mobileNumber: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: ""
    },
    avatarColor: {
      type: [String, Number],
      default: ""
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const s = t, a = I(!1), e = I(!1), d = k(() => s.username || s.mobileNumber), r = k(() => {
      var i, b;
      return (b = (i = s.username) == null ? void 0 : i.substring(0, 1)) == null ? void 0 : b.toUpperCase();
    }), h = k(() => !r.value && !s.avatar), l = k(() => h.value || e.value), c = k(() => l.value ? "" : s.avatarColor ? `#${Number(s.avatarColor).toString(16)}` : "#F4F5F7"), p = () => {
      if (a.value = !1, e.value = !1, !s.avatar)
        return;
      const i = new Image();
      i.onload = () => {
        a.value = !0;
      }, i.onerror = () => {
        e.value = !0;
      }, i.src = s.avatar;
    };
    return K(() => {
      s.avatar && p();
    }), (i, b) => (u(), v("div", _e, [
      g("div", {
        class: "patsnap-biz-avatar shrink-0",
        style: Q({
          backgroundImage: `url(${t.avatar})`,
          backgroundSize: "contain",
          backgroundColor: c.value
        })
      }, [
        !a.value && !e.value && r.value ? (u(), v("span", ke, S(r.value), 1)) : f("", !0),
        l.value ? (u(), L(o(N), {
          key: 1,
          icon: "SolidAvatarBlue",
          class: "text-3xl shrink-0"
        })) : f("", !0)
      ], 4),
      t.isOpen ? (u(), v("div", {
        key: 0,
        class: "text-xs text-white truncate flex-1",
        title: d.value
      }, S(d.value), 9, we)) : f("", !0),
      t.isOpen ? (u(), L(o(N), {
        key: 1,
        icon: "SolidArrowRight",
        class: "text-xl !fill-white shrink-0"
      })) : f("", !0)
    ]));
  }
}), W = "data-balloon-pos", Se = "[data-balloon-pos]";
function Pe(t) {
  const s = t.querySelector(Se);
  let a;
  return s && (a = s.getAttribute(W)), {
    hide() {
      s && s.removeAttribute(W);
    },
    show() {
      s && s.setAttribute(W, a);
    },
    visible(e) {
      e ? this.show() : this.hide();
    }
  };
}
function Le() {
  const t = I(!1), s = I(null);
  let a;
  return K(() => {
    a && a.visible(!t.value);
  }), R(() => {
    s.value && (a = Pe(s.value));
  }), pe(() => {
    a && (a = void 0);
  }), {
    visible: t,
    myElement: s
  };
}
const J = /* @__PURE__ */ z({
  __name: "HeaderDropdown",
  props: {
    /**
      * 触发 popper 出现的方式。默认为 click，可选值：click ｜ hover
    */
    trigger: {
      type: String,
      default: "click"
    },
    hideTimeout: {
      type: Number,
      default: 150
    },
    showTimeout: {
      type: Number,
      default: 250
    },
    isShowPopoverImmediate: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(t, { emit: s }) {
    const a = t, { visible: e, myElement: d } = Le(), r = G(), h = V(), l = k(() => r.align || "right"), c = I(0), p = I(0), i = () => {
      e.value = !1;
    };
    ee(d, i);
    const b = () => {
      if (a.trigger !== "hover") {
        e.value = !e.value;
        return;
      }
      s("click", { visible: e.value, close: i });
    }, _ = () => {
      a.trigger === "hover" && (clearTimeout(p.value), clearTimeout(c.value), c.value = window.setTimeout(() => {
        e.value = !1;
      }, a.hideTimeout));
    }, w = () => {
      a.trigger === "hover" && (clearTimeout(c.value), clearTimeout(p.value), p.value = window.setTimeout(() => {
        e.value = !0;
      }, a.showTimeout));
    };
    return de(
      () => a.isShowPopoverImmediate,
      (n) => {
        n && w();
      },
      { immediate: !0 }
    ), (n, m) => (u(), v("div", {
      ref_key: "myElement",
      ref: d,
      class: X(["patsnap-biz-nav-header-dropdown", [
        {
          "patsnap-biz-nav-header-dropdown--opened": o(e)
        },
        l.value
      ]])
    }, [
      g("div", {
        class: "patsnap-biz-nav-header-dropdown__reference",
        onMouseenter: w,
        onMouseleave: _,
        onClick: b
      }, [
        C(n.$slots, "reference", {
          open: o(e),
          close: i
        })
      ], 32),
      o(h).popper || o(h).popper ? me((u(), v("div", {
        key: 0,
        ref: "popper",
        class: "patsnap-biz-nav-header-dropdown__popper",
        onMouseenter: w,
        onMouseleave: _
      }, [
        C(n.$slots, "popper", {
          open: o(e),
          close: i
        })
      ], 544)), [
        [ge, o(e)]
      ]) : f("", !0)
    ], 2));
  }
}), Ce = {
  PtTenants: {
    switchTenantTitle: "确定切换组织并刷新页面吗？",
    switchTenantTip: "若您有正在编辑的内容，在点击“确定”后将不会被保存。请问是否继续切换组织？",
    ok: "确定",
    cancel: "取消",
    personalTenant: "个人账号",
    domainLimit: "域名限制",
    IPLimit: "IP限制",
    ssoLimit: "SSO限制",
    domainLimitTip: "您所在的组织要求您使用商务邮箱访问智慧芽，请通过邮箱登录。",
    IPLimitTip: "请在指定的IP范围内访问该产品。<br>您所在的组织希望您在指定地点（ 如办公室） 访问我们的产品。",
    dingdingTip: "您的管理员要求您通过钉钉的智慧芽应用登录。",
    feishuTip: "您的管理员要求您通过飞书的智慧芽应用登录。",
    wecomTip: "您的管理员要求您通过企业微信的智慧芽应用登录。",
    jwtTip: "您的管理员要求您通过内部认证服务器的智慧芽应用登录。",
    ssoTip: "您的管理员要求您通过SSO方式登录智慧芽产品。请通过您的内部认证服务器来访问智慧芽。",
    switchTenantFailed: "组织切换失败，请联系智慧芽客服人员。",
    accountStatusNotActiveTip: "您的邮箱未设置或未认证，请去用户设置-个人信息中认证邮箱。",
    youWillSwitchedTo: "您即将切换到：{tenantName}。",
    error31623: "对不起，为了您组织的数据安全，采用SSO-JWT对接方式则无法切换组织。"
  }
}, ze = {
  PtTenants: {
    switchTenantTitle: "Are you sure to switch to the organization and refresh the page?",
    // eslint-disable-next-line max-len
    switchTenantTip: 'If you have content being edited, it will be lost after clicking "Continue". Do you want to continue?',
    ok: "Continue",
    cancel: "Cancel",
    personalTenant: "Personal Account",
    domainLimit: "Domain Restrictions",
    IPLimit: "IP Restrictions",
    ssoLimit: "SSO Restrictions",
    // eslint-disable-next-line max-len
    domainLimitTip: "Your organization requires you to use your business email address to access PatSnap. Please login via email.",
    // eslint-disable-next-line max-len
    IPLimitTip: "Please access the product within the specified IP range.<br>For security reasons, your company has limited access to our products within specified locations e.g.designated offices.",
    dingdingTip: "Your administrator requires you to login via DingTalk to access PatSnap.",
    feishuTip: "Your administrator requires you to login via Feishu to access PatSnap.",
    wecomTip: "Your administrator requires you to login via WeCom to access PatSnap.",
    jwtTip: "Your administrator requires you to login via Internal Authentication Server to access PatSnap.",
    // eslint-disable-next-line max-len
    ssoTip: "Your administrator requires you to login via SSO to access PatSnap products.Please access PatSnap through your internal authentication server.",
    switchTenantFailed: "Failed to switch organization, please contact PatSnap customer service.",
    // eslint-disable-next-line max-len
    accountStatusNotActiveTip: "Sorry, your email is null or not verified, please go to Account - Personal Information to verify.",
    youWillSwitchedTo: "You will switch to {tenantName}.",
    error31623: "Sorry, your can't switch to others for data security because your organization use JWT for SSO."
  }
}, Ie = {
  PtTenants: {
    switchTenantTitle: "組織を切り替えてページを更新してもいいですか？",
    switchTenantTip: "「確定」をクリックすると、まだ編集中の操作は保存されませんが、やはり組織を切り替えますか？",
    ok: "確定",
    cancel: "キャンセル",
    personalTenant: "個人アカウント",
    domainLimit: "ドメイン制限",
    IPLimit: "IP 制限",
    ssoLimit: "SSO の制限",
    domainLimitTip: "ご所属の組織では、ビジネス用メールアドレスを用いてPatSnapにアクセスすることを要求されていますため、メールアドレスでログインしてください。",
    IPLimitTip: "指定されたIP範囲内で本製品にアクセスしてください。<br>御社はセキュリティ上の理由により、 弊社の製品にアクセスする場所を限定しています（ 例えば、 御社のオフィス）。",
    dingdingTip: "管理者の要求により、 DingTalk方式でPatsnap製品にログインする必要があります。",
    feishuTip: "管理者の要求により、 Feishu方式でPatsnap製品にログインする必要があります。",
    wecomTip: "管理者の要求により、 WeCom方式でPatsnap製品にログインする必要があります。",
    jwtTip: "管理者の要求により、 SSO方式でPatsnap製品にログインする必要があります。",
    ssoTip: "管理者の要求により、SSO方式でPatSnap製品にログインする必要があります。内部認証サーバーを介してスマートバッドにアクセスしてください。",
    switchTenantFailed: "組織の切り替えに失敗しました。PatSnapのカスタマーサービスにお問い合わせください。",
    accountStatusNotActiveTip: "あなたのメールアドレスは検証されていません。アカウント-個人情報に移動してメール検証を完了してください。",
    youWillSwitchedTo: "あなたは {tenantName} に切り替えようとしています。",
    error31623: "申し訳ありませんが、組織のデータセキュリティのため、SSO-JWTドッキングを使用して組織を切り替えることはできません。"
  }
}, $e = {
  PtTenants: {
    switchTenantTitle: "確定切換組織並刷新頁面嗎？",
    switchTenantTip: "若您有正在編輯的內容，在點擊“確定”後將不會被保存。請問是否繼續切換組織？",
    ok: "確定",
    cancel: "取消",
    personalTenant: "個人賬號",
    domainLimit: "域名限制",
    IPLimit: "IP限制",
    ssoLimit: "SSO限制",
    domainLimitTip: "您所在的組織要求您使用商務郵箱訪問智慧芽，請通過郵箱登錄。",
    IPLimitTip: "請在指定的IP範圍內訪問該產品。<br>您所在的組織希望您在指定地點（ 如辦公室） 訪問我們的產品。",
    dingdingTip: "您的管理員要求您通過釘釘的智慧芽應用登錄。",
    feishuTip: "您的管理員要求您通過飛書的智慧芽應用登錄。",
    wecomTip: "您的管理員要求您通過企業微信的智慧芽應用登錄。",
    jwtTip: "您的管理員要求您通過內部認證服務器的智慧芽應用登錄。",
    ssoTip: "您的管理員要求您通過SSO方式登錄智慧芽產品。請通過您的內部認證服務器來訪問智慧芽。",
    switchTenantFailed: "組織切換失敗，請聯繫智慧芽客服人員。",
    accountStatusNotActiveTip: "您的郵箱未設定或未認證，請去用戶設置-個人資訊中認證郵箱。",
    youWillSwitchedTo: "您即將切換到：{tenantName}。",
    error31623: "對不起，為了您組織的數據安全，採用SSO-JWT對接方式則無法切換組織。"
  }
}, Ne = { class: "patsnap-biz-nav-tenants__title" }, Ae = ["innerHTML"], Oe = { class: "patsnap-biz-nav-tenants__list-item" }, je = { class: "patsnap-ui-list-item__content" }, He = { class: "patsnap-biz-nav-tenants__tags" }, De = {
  key: 0,
  class: "patsnap-biz-nav-tenants__tag"
}, xe = {
  key: 1,
  class: "patsnap-biz-nav-tenants__tag"
}, Ve = {
  key: 2,
  class: "patsnap-biz-nav-tenants__tag"
}, Fe = {
  key: 1,
  class: "patsnap-biz-nav-tenants__title"
}, Ee = { class: "patsnap-biz-nav-tenants__title-content" }, Ue = /* @__PURE__ */ g("br", null, null, -1), Be = { class: "dialog-footer" }, Me = ["disabled"], We = ["disabled"], ne = /* @__PURE__ */ z({
  __name: "Tenants",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  setup(t) {
    const s = t, a = G(), { t: e } = O({
      fallbackLocale: "cn",
      messages: {
        cn: Ce,
        en: ze,
        jp: Ie,
        tw: $e
      }
    }), d = I(!1), r = Z("service"), h = k(() => r.currentSwitchTenantInfo), l = k(
      () => s.value.map((n) => ({
        ...n,
        label: (n == null ? void 0 : n.label) || e("PtTenants.personalTenant"),
        postIcon: "SolidTick"
      }))
    ), c = k(() => {
      const n = l.value.find((m) => !!m.active);
      return n == null ? void 0 : n.label;
    }), p = k(() => l.value.length > 1), i = k(() => {
      var n;
      return !p.value && !!((n = l.value[0]) != null && n.tenant_id);
    });
    function b(n) {
      n.active || n.disabled || (r.currentSwitchTenantInfo = n, r.switchTenantDialogVisible = !0);
    }
    function _() {
      d.value = !0, r.switchTenants(h.value.tenant_id).then(() => {
        r.switchTenantDialogVisible = !1;
      }).catch((n) => {
        const m = $.get(n, "response.data.numeric_error_code"), P = `PtTenants.error${m}` !== e(`PtTenants.error${m}`);
        Te({
          type: "error",
          message: e(P ? `PtTenants.error${m}` : "PtTenants.switchTenantFailed"),
          duration: 3e3
        });
      }).finally(() => {
        d.value = !1;
      });
    }
    function w(n) {
      const m = [];
      return n.account_status_active || m.push(e("PtTenants.accountStatusNotActiveTip")), n.domain_restrict && m.push(e("PtTenants.domainLimitTip")), n.ip_restrict && m.push(e("PtTenants.IPLimitTip")), n.sso_restrict && (n.sso_restrict_type === "DINGTLK" ? m.push(e("PtTenants.dingdingTip")) : n.sso_restrict_type === "FEISHU" ? m.push(e("PtTenants.feishuTip")) : n.sso_restrict_type === "WECHAT_ENTERPRISE" ? m.push(e("PtTenants.wecomTip")) : n.sso_restrict_type === "JWT" ? m.push(e("PtTenants.jwtTip")) : m.push(e("PtTenants.ssoTip"))), m.join('<div style="margin-bottom: 8px"></div>');
    }
    return (n, m) => (u(), v("div", null, [
      p.value ? (u(), L(J, {
        key: 0,
        class: "patsnap-biz-nav-tenants",
        trigger: o(a).trigger
      }, {
        reference: T(() => [
          g("div", Ne, [
            y(o(te), {
              class: "patsnap-biz-nav-tenants__widget",
              label: c.value,
              "post-icon": l.value.length > 1 ? "SolidChangeOrder" : ""
            }, null, 8, ["label", "post-icon"])
          ])
        ]),
        popper: T(() => [
          y(o(F), {
            class: "patsnap-biz-nav-tenants__popper",
            items: l.value,
            onItemClick: b
          }, {
            default: T(({ item: P }) => [
              y(o(ye), {
                disabled: !P.disabled,
                effect: "light",
                placement: "right",
                offset: 8,
                "visible-arrow": !1,
                "popper-class": "patsnap-biz-nav-tenants__tooltip"
              }, {
                content: T(() => [
                  g("div", {
                    innerHTML: w(P)
                  }, null, 8, Ae)
                ]),
                default: T(() => [
                  g("div", Oe, [
                    g("div", je, [
                      g("span", null, S(P.label), 1),
                      g("div", He, [
                        P.domain_restrict ? (u(), v("div", De, S(o(e)("PtTenants.domainLimit")), 1)) : f("", !0),
                        P.ip_restrict ? (u(), v("div", xe, S(o(e)("PtTenants.IPLimit")), 1)) : f("", !0),
                        P.sso_restrict ? (u(), v("div", Ve, S(o(e)("PtTenants.ssoLimit")), 1)) : f("", !0)
                      ])
                    ]),
                    P.postIcon ? (u(), L(o(N), {
                      key: 0,
                      icon: P.postIcon,
                      class: "patsnap-ui-list-item__post-icon"
                    }, null, 8, ["icon"])) : f("", !0)
                  ])
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]),
            _: 1
          }, 8, ["items"])
        ]),
        _: 1
      }, 8, ["trigger"])) : f("", !0),
      i.value ? (u(), v("div", Fe, [
        g("div", Ee, S(c.value), 1)
      ])) : f("", !0),
      o(r).switchTenantDialogVisible ? (u(), L(o(be), {
        key: 2,
        visible: o(r).switchTenantDialogVisible,
        "onUpdate:visible": m[1] || (m[1] = (P) => o(r).switchTenantDialogVisible = P),
        title: o(e)("PtTenants.switchTenantTitle"),
        "append-to-body": !0,
        "close-on-click-modal": !1,
        "close-on-press-escape": !1,
        width: "400px",
        class: "patsnap-biz-nav-tenants__switch-dialog"
      }, {
        footer: T(() => [
          g("span", Be, [
            g("button", {
              class: "pt-ui-btn mr-2",
              "data-size": "medium",
              disabled: d.value,
              onClick: m[0] || (m[0] = (P) => o(r).switchTenantDialogVisible = !1)
            }, [
              g("span", null, S(o(e)("PtTenants.cancel")), 1)
            ], 8, Me),
            g("button", {
              class: "pt-ui-btn patsnap-biz-nav-tenants__switch-dialog__confirm-btn",
              "data-type": "primary",
              "data-size": "medium",
              disabled: d.value,
              onClick: _
            }, [
              g("span", {
                style: Q({ opacity: d.value ? 0 : 1 })
              }, S(o(e)("PtTenants.ok")), 5),
              d.value ? (u(), L(o(N), {
                key: 0,
                icon: "SolidLoadingBars",
                class: "fill-white"
              })) : f("", !0)
            ], 8, We)
          ])
        ]),
        default: T(() => [
          g("div", null, [
            D(S(o(e)("PtTenants.youWillSwitchedTo", { tenantName: h.value.label })), 1),
            Ue,
            D(" " + S(o(e)("PtTenants.switchTenantTip")), 1)
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"])) : f("", !0)
    ]));
  }
}), qe = {
  key: 0,
  class: "patsnap-biz-nav-user-banner"
}, Re = {
  key: 0,
  class: "patsnap-biz-nav-user-banner__item"
}, Ge = {
  key: 0,
  class: "patsnap-biz-nav-user-banner__item"
}, Ye = {
  key: 1,
  class: "patsnap-biz-nav-user-banner__item"
}, Je = /* @__PURE__ */ g("li", { class: "patsnap-biz-nav-user-banner__divider" }, null, -1), se = /* @__PURE__ */ z({
  __name: "UserBanner",
  props: {
    account: {
      type: Object,
      required: !1,
      default: () => {
      }
    }
  },
  setup(t) {
    const s = t, a = k(() => s.account ? !(!s.account.companyName && !s.account.username && !s.account.email && !s.account.mobileNumber) : !1);
    return (e, d) => a.value ? (u(), v("ul", qe, [
      C(e.$slots, "username", {}, () => [
        t.account.username ? (u(), v("li", Re, S(t.account.username), 1)) : f("", !0)
      ]),
      t.account.email ? (u(), v("li", Ge, S(t.account.email), 1)) : f("", !0),
      t.account.mobileNumber ? (u(), v("li", Ye, S(t.account.mobileNumber), 1)) : f("", !0),
      C(e.$slots, "userPackageType"),
      Je
    ])) : f("", !0);
  }
}), ie = /* @__PURE__ */ z({
  __name: "LanguageList",
  setup(t) {
    const s = Z("service"), a = k(() => $.map(s.locales, (d) => ({
      ...d,
      postIcon: "SolidTick"
    }))), e = (d) => {
      s.setLocale(d.key);
    };
    return (d, r) => (u(), L(o(F), {
      class: "patsnap-biz-nav-languages__popper",
      items: a.value,
      onItemClick: e
    }, null, 8, ["items"]));
  }
}), oe = {
  PtSelectLanguage: {
    language: "语言"
  }
}, re = {
  PtSelectLanguage: {
    language: "Language"
  }
}, le = {
  PtSelectLanguage: {
    language: "言语"
  }
}, ce = {
  PtSelectLanguage: {
    language: "語言"
  }
}, ue = /* @__PURE__ */ z({
  __name: "Languages",
  props: {
    arrow: {
      type: String,
      default: ""
    },
    mini: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["handleLanguageClick"],
  setup(t, { emit: s }) {
    const a = G(), { t: e } = O({
      fallbackLocale: "cn",
      messages: {
        cn: oe,
        en: re,
        jp: le,
        tw: ce
      }
    });
    function d() {
      s("handleLanguageClick");
    }
    return (r, h) => (u(), L(J, {
      class: "patsnap-biz-nav-languages",
      trigger: o(a).trigger
    }, {
      reference: T(({ open: l }) => [
        y(o(te), ve({
          [t.mini ? "" : "label"]: o(e)("PtSelectLanguage.language"),
          [t.mini ? "" : "post-icon"]: t.arrow === "down" ? l ? "SolidDropdownClose" : "SolidDropdownOpen" : "SolidDropdownRight"
        }, {
          icon: "SolidTranslateEnglish",
          class: ["patsnap-biz-nav-header-widget", { "hover:!bg-transparent": t.mini }],
          onClick: d
        }), null, 16, ["class"])
      ]),
      popper: T(() => [
        y(ie)
      ]),
      _: 1
    }, 8, ["trigger"]));
  }
}), E = {
  PtHeader: {
    help: "帮助",
    // ヘルプ
    helpCenter: "帮助中心",
    // ヘルプセンター
    quickStartGuide: "新手入门",
    // 初心者向けガイド
    gettingStartedVideos: "入门视频",
    // 入門ビデオ
    searchHelper: "搜索帮助",
    // 検索ヘルプ
    releaseLog: "最新功能",
    // リリース履歴
    dataCoverage: "数据范围",
    // データ収録範囲
    askForHelp: "需要帮助",
    // お問合せ
    products: "产品",
    workspace: "工作空间",
    marketPlace: "导航库中心",
    analytics: "专利数据库",
    insights: "英策",
    bio: "Bio",
    chemical: "Chemical",
    discovery: "Discovery",
    synapse: "新药情报库",
    academy: "智慧芽学社",
    course: "智慧芽学社",
    course2b: "企业版学社",
    lab: "PatSnap Lab",
    open: "数据服务平台",
    ipAsset: "资产管理",
    allProducts: "产品",
    tffi: "TFFI",
    eureka: "Eureka",
    pharmsnap: "PharmSnap"
  },
  PtUserCenter: {
    login: "登录",
    logout: "登出",
    account: "用户设置",
    adminSettings: "管理员工作台",
    team: "团队",
    projectTimer: "项目计时",
    personal: "个人",
    enterprise: "企业"
  }
}, U = {
  PtHeader: {
    help: "Help",
    // ヘルプ
    helpCenter: "Help Center",
    // ヘルプセンター
    quickStartGuide: "Quick Start Guide",
    // 初心者向けガイド
    gettingStartedVideos: "Getting Started Videos",
    // 入門ビデオ
    searchHelper: "Search Helper",
    // 検索ヘルプ
    releaseLog: "Release Log",
    // リリース履歴
    dataCoverage: "Data Coverage",
    // データ収録範囲
    askForHelp: "Ask For Help",
    // お問合せ
    products: "Products",
    workspace: "Workspace",
    marketPlace: "Marketplace",
    analytics: "Analytics",
    insights: "Insights",
    bio: "Bio",
    chemical: "Chemical",
    discovery: "Discovery",
    synapse: "Synapse",
    academy: "Academy",
    course: "Academy",
    course2b: "Course",
    lab: "PatSnap Lab",
    open: "Data Service",
    ipAsset: "IP Asset",
    allProducts: "Products",
    tffi: "TFFI",
    eureka: "Eureka",
    pharmsnap: "PharmSnap"
  },
  PtUserCenter: {
    login: "Login",
    logout: "Logout",
    account: "Account",
    adminSettings: "Admin Settings",
    team: "Team",
    projectTimer: "Project Timer",
    personal: "Personal",
    enterprise: "Enterprise"
  }
}, B = {
  PtHeader: {
    help: "ヘルプ",
    // ヘルプ
    helpCenter: "ヘルプセンター",
    // ヘルプセンター
    quickStartGuide: "初心者向けガイド",
    // 初心者向けガイド
    gettingStartedVideos: "入門ビデオ",
    // 入門ビデオ
    searchHelper: "検索ヘルプ",
    // 検索ヘルプ
    releaseLog: "リリース履歴",
    // リリース履歴
    dataCoverage: "データ収録範囲",
    // データ収録範囲
    askForHelp: "お問合せ",
    // お問合せ
    products: "製品",
    workspace: "Workspace",
    marketPlace: "Marketplace",
    analytics: "Analytics",
    insights: "Insights",
    bio: "Bio",
    chemical: "Chemical",
    discovery: "Discovery",
    synapse: "Synapse",
    academy: "Academy",
    course: "Academy",
    course2b: "Course",
    lab: "PatSnap Lab",
    open: "Data Service",
    ipAsset: "IP Asset",
    allProducts: "製品",
    tffi: "TFFI",
    eureka: "Eureka",
    pharmsnap: "PharmSnap"
  },
  PtUserCenter: {
    login: "ログイン",
    logout: "ログアウト",
    account: "アカウント",
    adminSettings: "管理設定",
    team: "チーム",
    projectTimer: "タイマー",
    personal: "個人",
    enterprise: "企業"
  }
}, M = {
  PtHeader: {
    help: "幫助",
    // ヘルプ
    helpCenter: "幫助中心",
    // ヘルプセンター
    quickStartGuide: "新手入門",
    // 初心者向けガイド
    gettingStartedVideos: "入門視頻",
    // 入門ビデオ
    searchHelper: "搜索幫助",
    // 検索ヘルプ
    releaseLog: "最新功能",
    // リリース履歴
    dataCoverage: "數據範圍",
    // データ収録範囲
    askForHelp: "需要幫助",
    // お問合せ
    products: "産品",
    workspace: "工作空間",
    marketPlace: "導航庫中心",
    analytics: "專利數據庫",
    insights: "英策",
    bio: "Bio",
    chemical: "Chemical",
    discovery: "Discovery",
    synapse: "新藥情報庫",
    academy: "智慧芽學社",
    course: "智慧芽學社",
    course2b: "企業版學社",
    lab: "PatSnap Lab",
    open: "數據服務平台",
    ipAsset: "資産管理",
    allProducts: "産品",
    tffi: "TFFI",
    eureka: "Eureka",
    pharmsnap: "PharmSnap"
  },
  PtUserCenter: {
    login: "登錄",
    logout: "登出",
    account: "用戶設置",
    adminSettings: "管理員工作臺",
    team: "團隊",
    projectTimer: "項目計時",
    language: "語言",
    personal: "個人",
    enterprise: "企業"
  }
}, Ke = {
  key: 0,
  class: "patsnap-biz-user-center-popup"
}, Qe = /* @__PURE__ */ z({
  __name: "UserCenterPopup",
  props: {
    service: {},
    trigger: { default: "" }
  },
  emits: ["handleLanguageClick"],
  setup(t, { emit: s }) {
    const a = t, { t: e } = O({
      fallbackLocale: "cn",
      messages: {
        cn: E,
        en: U,
        jp: B,
        tw: M
      }
    });
    Y("service", a.service);
    const d = V(), r = k(() => {
      const l = [
        "default",
        "logo",
        A(a.service.title),
        ...$.map(a.service.right, (p) => A(p)),
        ...$.map(a.service.left, (p) => A(p))
      ].filter((p) => p);
      return $.filter(Object.keys(d), (p) => !l.includes(p));
    }), h = k(
      () => $.map($.get(a.service, "userCenterService.items"), (l) => {
        if (l === null)
          return null;
        if (typeof l == "string")
          return e(l) ? e(l) : l;
        const {
          i18n: c,
          label: p,
          key: i,
          ...b
        } = l;
        return {
          label: c && e(c) ? e(c) : p || c,
          key: i,
          ...b
        };
      })
    );
    return (l, c) => l.service ? (u(), v("div", Ke, [
      y(ne, {
        value: l.service.tenants,
        trigger: l.trigger
      }, null, 8, ["value", "trigger"]),
      y(se, {
        account: l.service.account
      }, x({ _: 2 }, [
        j(r.value, (p) => ({
          name: p,
          fn: T(() => [
            C(l.$slots, p)
          ])
        }))
      ]), 1032, ["account"]),
      y(o(F), {
        class: "patsnap-biz-nav-user_center_menu",
        items: h.value
      }, {
        language: T(() => [
          y(ue, {
            ref: "language",
            trigger: l.trigger,
            onHandleLanguageClick: c[0] || (c[0] = (p) => s("handleLanguageClick"))
          }, null, 8, ["trigger"])
        ]),
        default: T(() => [
          (u(!0), v(q, null, j(o(d), (p, i) => (u(), v(q, null, [
            i !== "header" && i !== "language" ? C(l.$slots, i, { key: 0 }) : f("", !0)
          ], 64))), 256))
        ]),
        _: 3
      }, 8, ["items"])
    ])) : f("", !0);
  }
}), Xe = { class: "patsnap-biz-mobile-user-modal fixed h-full left-0 top-[46px] z-[2000] flex flex-col w-full overflow-hidden" }, Ze = /* @__PURE__ */ g("div", { class: "absolute left-0 top-0 h-full w-full bg-black bg-opacity-50" }, null, -1), et = { class: "flex flex-col" }, tt = /* @__PURE__ */ z({
  __name: "UserDrawer",
  props: {
    service: {},
    closeOnClickModal: { type: Boolean, default: !0 },
    modelValue: { type: Boolean }
  },
  emits: ["onClose", "onOpen", "update:modelValue"],
  setup(t, { emit: s }) {
    const a = t;
    Y("service", a.service);
    function e() {
      s("onClose");
    }
    const d = I(null);
    ee(
      d,
      () => {
        a.closeOnClickModal && e();
      }
    ), R(() => {
      s("onOpen");
    });
    function r() {
      s("update:modelValue", !0);
    }
    return (h, l) => (u(), v("div", Xe, [
      Ze,
      g("div", {
        ref_key: "userModalRef",
        ref: d,
        class: "z-10 w-full bg-white patsnap-biz-mobile-user-modal-body"
      }, [
        g("div", et, [
          h.modelValue ? (u(), L(ie, { key: 0 })) : (u(), L(Qe, {
            key: 1,
            service: h.service,
            onHandleLanguageClick: r
          }, null, 8, ["service"]))
        ])
      ], 512)
    ]));
  }
}), H = {
  cn: oe,
  en: re,
  jp: le,
  tw: ce
}, at = { class: "patsnap-biz-mobile-user-center" }, nt = {
  key: 0,
  class: "patsnap-biz-nav-user_center--not-logged-in justify-center items-center gap-3"
}, st = /* @__PURE__ */ z({
  __name: "MobileUserCenter",
  props: {
    service: {}
  },
  emits: ["clickLogin"],
  setup(t, { emit: s }) {
    const a = t, e = {
      cn: { ...E, ...H.cn },
      en: { ...U, ...H.en },
      jp: { ...B, ...H.jp },
      tw: { ...M, ...H.tw }
    }, { t: d } = O({
      fallbackLocale: "cn",
      messages: e
    }), r = k(() => a.service.userCenterService), h = I(!1), l = I(!1);
    function c(w, n) {
      h.value = w, l.value = n;
    }
    function p() {
      c(!0, !1);
    }
    function i() {
      h.value = !1;
    }
    function b() {
      c(!0, !0);
    }
    function _() {
      if (r.value.beforeLogin) {
        const { loginHref: w, logoutHref: n } = r.value;
        r.value.beforeLogin({ loginHref: w, logoutHref: n });
      }
      s("clickLogin");
    }
    return (w, n) => {
      var m;
      return u(), v("div", at, [
        r.value.logged ? (u(), L(ae, {
          key: 1,
          "is-open": !1,
          username: r.value.name,
          avatar: r.value.avatar,
          email: r.value.email,
          "mobile-number": (m = w.service.account) == null ? void 0 : m.mobileNumber,
          "avatar-color": r.value.avatarColor,
          onClick: p
        }, null, 8, ["username", "avatar", "email", "mobile-number", "avatar-color"])) : (u(), v("div", nt, [
          g("div", {
            class: "patsnap-biz-nav-user_center--login th-btn th-btn-plain !bg-white/20 flex flex-row justify-center gap-2 !text-xs",
            type: "primary",
            onClick: _
          }, [
            y(o(N), {
              icon: "SolidLogin",
              class: "!mb-0 w-6 h-6 text-2xl"
            }),
            D(" " + S(o(d)("PtUserCenter.login")), 1)
          ]),
          g("div", {
            class: "th-btn th-btn-plain th-btn-only-icon th-btn-md patsnap-biz-nav-user_center--login !bg-white/10 rounded",
            onClick: b
          }, [
            y(o(N), {
              icon: "SolidTranslateEnglish",
              class: "!mb-0 w-6 h-6 text-2xl"
            })
          ])
        ])),
        h.value ? (u(), L(tt, {
          key: 2,
          modelValue: l.value,
          "onUpdate:modelValue": n[0] || (n[0] = (P) => l.value = P),
          service: w.service,
          onOnClose: i
        }, null, 8, ["modelValue", "service"])) : f("", !0)
      ]);
    };
  }
}), it = { class: "patsnap-biz-nav-user_center w-full" }, ot = { class: "!bg-white/10 th-btn th-btn-plain th-btn-only-icon th-btn-xl !rounded-lg !w-12" }, rt = /* @__PURE__ */ z({
  __name: "NavUserCenter",
  props: {
    service: {
      type: Object,
      default: () => new fe()
    },
    open: {
      type: Boolean,
      default: !1
    },
    mobileNumber: {
      type: String,
      default: ""
    }
  },
  emits: ["clickLogin"],
  setup(t, { emit: s }) {
    const a = t, e = V(), d = k(() => {
      const c = ["default", "language"];
      return Object.keys(e).filter((i) => !c.includes(i));
    }), { t: r } = O({
      fallbackLocale: "cn",
      messages: {
        cn: E,
        en: U,
        jp: B,
        tw: M
      }
    }), h = k(
      () => a.service.items.map((c) => {
        if (c === null)
          return null;
        if (typeof c == "string")
          return r(c) ? r(c) : c;
        const {
          i18n: p,
          label: i,
          key: b,
          ..._
        } = c;
        return {
          label: p && r(p) ? r(p) : i || p,
          key: b,
          ..._
        };
      })
    );
    function l() {
      if (a.service.beforeLogin) {
        const { loginHref: c, logoutHref: p } = a.service;
        a.service.beforeLogin({ loginHref: c, logoutHref: p });
      }
      s("clickLogin");
    }
    return (c, p) => (u(), v("div", it, [
      t.service.logged ? (u(), L(J, {
        key: 1,
        trigger: "hover",
        class: "patsnap-biz-nav-user_center--logged w-full"
      }, {
        reference: T(() => [
          y(ae, {
            class: "bg-white/10 px-2 rounded-lg",
            "is-open": t.open,
            username: t.service.name,
            avatar: t.service.avatar,
            email: t.service.email,
            "mobile-number": t.mobileNumber,
            "avatar-color": t.service.avatarColor
          }, null, 8, ["is-open", "username", "avatar", "email", "mobile-number", "avatar-color"])
        ]),
        popper: T(() => [
          C(c.$slots, "header", { trigger: "hover" }),
          y(o(F), {
            class: "patsnap-biz-nav-user_center_menu",
            items: h.value
          }, x({
            language: T(() => [
              C(c.$slots, "language", { trigger: "hover" })
            ]),
            _: 2
          }, [
            j(d.value, (i) => ({
              name: i,
              fn: T(() => [
                C(c.$slots, i)
              ])
            }))
          ]), 1032, ["items"])
        ]),
        _: 3
      })) : (u(), v("div", {
        key: 0,
        class: X(["patsnap-biz-nav-user_center--not-logged-in justify-center items-center gap-3", { "!flex": !t.open }])
      }, [
        g("div", {
          class: "patsnap-biz-nav-user_center--login th-btn th-btn-plain th-btn-xl !rounded-lg !bg-white/20 flex flex-row justify-center gap-2 !text-sm",
          type: "primary",
          onClick: l
        }, [
          y(o(N), {
            icon: "SolidLogin",
            class: "!mb-0 w-6 h-6 text-2xl"
          }),
          D(" " + S(o(r)("PtUserCenter.login")), 1)
        ]),
        g("div", ot, [
          t.open ? C(c.$slots, "language", { key: 0 }) : f("", !0)
        ])
      ], 2))
    ]));
  }
}), lt = /* @__PURE__ */ z({
  __name: "PCUserCenter",
  props: {
    service: {
      type: Object,
      default() {
        return new he();
      }
    },
    open: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["clickLogin"],
  setup(t, { emit: s }) {
    const a = t;
    function e(i) {
      for (; i.lastChild; )
        i.removeChild(i.lastChild);
      return i;
    }
    const d = I(null);
    O({
      fallbackLocale: "cn",
      messages: {
        cn: E,
        en: U,
        jp: B,
        tw: M
      }
    });
    const r = V();
    Y("service", a.service);
    const h = k(() => {
      const i = [
        "default",
        "logo",
        A(a.service.title),
        ...a.service.right.map((_) => A(_)),
        ...a.service.left.map((_) => A(_))
      ].filter((_) => _);
      return Object.keys(r).filter((_) => !i.includes(_));
    });
    function l(i) {
      a.service.setLocale(i);
    }
    function c() {
      const { mountElement: i } = a.service;
      let b;
      i instanceof HTMLElement ? b = i : typeof i == "string" && (b = document.querySelector(i)), b && e(b).appendChild(d.value);
    }
    function p() {
      s("clickLogin");
    }
    return R(() => {
      c();
    }), (i, b) => {
      var _;
      return u(), v("div", {
        ref_key: "root",
        ref: d,
        class: "patsnap-biz-nav-header patsnap-biz-nav-user-avatar"
      }, [
        y(rt, {
          ref: "userCenter",
          open: t.open,
          service: t.service.userCenterService,
          "mobile-number": (_ = t.service.account) == null ? void 0 : _.mobileNumber,
          onClickLogin: p
        }, x({
          header: T(({ trigger: w }) => [
            y(ne, {
              value: t.service.tenants,
              trigger: w
            }, null, 8, ["value", "trigger"]),
            y(se, {
              account: t.service.account
            }, x({ _: 2 }, [
              j(h.value, (n) => ({
                name: n,
                fn: T(() => [
                  C(i.$slots, n)
                ])
              }))
            ]), 1032, ["account"])
          ]),
          language: T(({ trigger: w }) => {
            var n, m;
            return [
              y(ue, {
                ref: "language",
                value: t.service.locales,
                trigger: w,
                arrow: w ? "right" : "down",
                mini: !((m = (n = t.service) == null ? void 0 : n.userCenterService) != null && m.logged),
                onChange: l
              }, null, 8, ["value", "trigger", "arrow", "mini"])
            ];
          }),
          _: 2
        }, [
          j(o(r), (w, n) => ({
            name: n,
            fn: T(() => [
              n !== "header" && n !== "language" ? C(i.$slots, n, { key: 0 }) : f("", !0)
            ])
          }))
        ]), 1032, ["open", "service", "mobile-number"])
      ], 512);
    };
  }
}), ct = /* @__PURE__ */ z({
  __name: "NavUserAvatar",
  props: {
    service: {},
    open: { type: Boolean, default: !1 }
  },
  emits: ["clickLogin"],
  setup(t, { emit: s }) {
    function a() {
      s("clickLogin");
    }
    return (e, d) => (u(), v(q, null, [
      y(st, {
        class: "flex xl:hidden patsnap-biz-nav-header",
        service: e.service,
        onClickLogin: a
      }, null, 8, ["service"]),
      y(lt, {
        class: "hidden xl:block",
        service: e.service,
        open: e.open,
        onClickLogin: a
      }, null, 8, ["service", "open"])
    ], 64));
  }
}), Dt = ct;
export {
  Dt as PtNavUserAvatar,
  Dt as default
};
